export enum USER_FIELDS {
	USER_IDS = "userIds",
	ID = "id",
	TEXT = "text",
	AVATAR_FILE = "avatarFile",
	AVATAR = "avatar",
	DESKTOP = "deskTop",
	// dfw42qf@mail.ru
	DIVISION_ID = "divisionId",
	MANAGER_ID = "managerId",

	LOGIN = "login",
	STATUS = "status",
	PAGE_N = "pageN",
	PAGE_SIZE = "pageSize",
	NAME = "name",
	LAST_NAME = "lastName",
	POSITION = "position",
	MIDDLE_NAME = "middleName",
	LENGTH = "length",
	EMAIL = "email",
	REASON = "reason",
	ROLE_ID = "roleId",
	CREATED_AT = "createdDate",
	DIVISION = "division",
	MANAGER = "manager",
	FULL_NAME = "fullName",
	CREATED_AT_FORMATTED = "createdAtFormatted",
	RESULT = "result",
	ROLE = "role",
	IMAGE = "image",
	UID = "uid",
	CREATOR_USER_ID = "creatorUserId",
	USER = "user",
	USER_ID = "userId",
	PWD = "pwd",
	OPEN = "open",
	UREQIDS = "ureqIds",
	URID = "urid",
	IS_DONE = "isDone",
}
